import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable'
import { useMediaQuery } from '@uidotdev/usehooks'
import type { ReactNode } from 'react'

type PosWorkspaceLayoutProps = {
  header: ReactNode
  /** Notices under the header, above the catalog and cart. */
  banners?: ReactNode
  catalog: ReactNode
  cart: ReactNode
}

/**
 * The POS screen: the catalog beside the cart on a wide screen, the cart above the catalog on a narrow one. Create
 * Order and Edit Order share it.
 */
export function PosWorkspaceLayout({ header, banners, catalog, cart }: PosWorkspaceLayoutProps) {
  const isLargeScreen = useMediaQuery('(min-width: 1024px)')

  return (
    <div className="relative flex flex-col lg:h-[calc(100dvh-5.5rem)] lg:min-h-0 lg:overflow-hidden">
      <div className="mb-3 shrink-0">{header}</div>
      {banners}
      <div className="flex-1 lg:min-h-0 lg:overflow-hidden">
        {isLargeScreen ? (
          <div className="hidden h-full min-h-0 overflow-hidden lg:block">
            <ResizablePanelGroup direction="horizontal" className="h-full items-stretch">
              <ResizablePanel defaultSize={60} minSize={40}>
                <div className="flex h-full min-h-0 flex-col overflow-hidden pr-2">{catalog}</div>
              </ResizablePanel>
              <ResizableHandle withHandle className="self-stretch" />
              <ResizablePanel defaultSize={40} minSize={35}>
                <div className="flex h-full min-h-0 flex-col overflow-visible pl-2">{cart}</div>
              </ResizablePanel>
            </ResizablePanelGroup>
          </div>
        ) : (
          <div className="flex flex-col gap-4 lg:hidden">
            {cart}
            {catalog}
          </div>
        )}
      </div>
    </div>
  )
}
